module.exports = __webpack_public_path__ + "media/images/client-20-3953eb39d085006e97ff349cb9762759.png";